import { render } from "./AuditTestQuiz.vue?vue&type=template&id=05deba98&scoped=true"
import script from "./AuditTestQuiz.vue?vue&type=script&lang=js"
export * from "./AuditTestQuiz.vue?vue&type=script&lang=js"

import "./AuditTestQuiz.vue?vue&type=style&index=0&id=05deba98&scoped=true&lang=css"

import exportComponent from "/home/bshipaa/sites/app.bitesizehipaa.com/bss/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05deba98"]])

export default __exports__